import React from 'react'
import {useMutation, useQueryClient} from '@tanstack/react-query';
import {auth} from '../../../components/Auth/Auth.jsx'


const UpdateLogsTable = async(macs) => {
    const user = auth.currentUser;

    if(!macs){
        return null;
    }

    if(!user){
  throw new Error('No authenticated user found');

}

    const token = await user.getIdToken();

     

     

    const response = await fetch(`${import.meta.env.VITE_LOGS_API_URL}`,{
         method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({macs})
    });
    if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Unauthorized: Please log in again.');
    }
    throw new Error('Network response was not ok');
  }
  return response.json();
};

export const useUpdateTableNotif = (shopId,options) =>{
     const queryClient = useQueryClient();

     return useMutation({
         mutationFn: UpdateLogsTable,
         onSuccess: (data,variables,context) => {
             if(shopId){
            queryClient.invalidateQueries({queryKey: ['ShopControllers', shopId]});
             } else{
                queryClient.invalidateQueries({queryKey: ['ShopControllers']});
             }

             options?.onSuccess?.(data,variables,context);
            },
            onError: (error,variables,context) => {
                options?.onError?.(error,variables,context);
            },
         ...options,



     });
};
    

